{
  "policy": {
    "plateStep": 2.5,
    "microPlateStep": 1.25,
    "microPlateThreshold": 30,
    "clampLow": 0.5,
    "clampHigh": 1.5
  },
  "deriveBackoff": [
    {
      "top": 100,
      "percent": 0.85,
      "expected": 85.0
    },
    {
      "top": 100,
      "percent": 0.80,
      "expected": 80.0
    },
    {
      "top": 100,
      "percent": 0.90,
      "expected": 90.0
    },
    {
      "top": 100,
      "percent": 0.83,
      "expected": 82.5
    },
    {
      "top": 100,
      "percent": 0.40,
      "expected": 50.0
    },
    {
      "top": 100,
      "percent": 0.10,
      "expected": 50.0
    },
    {
      "top": 25,
      "percent": 0.85,
      "expected": 21.25
    },
    {
      "top": 28,
      "percent": 0.85,
      "expected": 23.75
    },
    {
      "top": 0,
      "percent": 0.85,
      "expected": null
    },
    {
      "top": null,
      "percent": 0.85,
      "expected": null
    },
    {
      "top": 100,
      "percent": null,
      "expected": null
    },
    {
      "top": null,
      "percent": null,
      "expected": null
    }
  ],
  "roundToPlates": [
    {
      "weight": 85,
      "expected": 85.0
    },
    {
      "weight": 83,
      "expected": 82.5
    },
    {
      "weight": 84,
      "expected": 85.0
    },
    {
      "weight": 29.9,
      "expected": 30.00
    },
    {
      "weight": 30,
      "expected": 30.0
    },
    {
      "weight": 30.1,
      "expected": 30.0
    },
    {
      "weight": 31.25,
      "expected": 32.5
    },
    {
      "weight": 22,
      "expected": 22.50
    },
    {
      "weight": 1.24,
      "expected": 1.25
    },
    {
      "weight": 0.5,
      "expected": 0.00
    },
    {
      "weight": 0,
      "expected": 0.00
    }
  ],
  "clampToReference": [
    {
      "resolved": 85,
      "reference": 100,
      "expected": 85
    },
    {
      "resolved": 200,
      "reference": 100,
      "expected": 150.0
    },
    {
      "resolved": 40,
      "reference": 100,
      "expected": 50.0
    },
    {
      "resolved": 100,
      "reference": 100,
      "expected": 100
    },
    {
      "resolved": 50,
      "reference": 100,
      "expected": 50
    },
    {
      "resolved": 150,
      "reference": 100,
      "expected": 150
    },
    {
      "resolved": 85,
      "reference": -100,
      "expected": 85
    },
    {
      "resolved": 10,
      "reference": 0,
      "expected": 0.0
    }
  ],
  "advance": [
    {
      "baseValue": 100,
      "field": "Weight",
      "delta": 2.5,
      "unit": "Absolute",
      "cycleOffset": 0,
      "expected": 100
    },
    {
      "baseValue": 100,
      "field": "Weight",
      "delta": 2.5,
      "unit": "Absolute",
      "cycleOffset": 3,
      "expected": 107.5
    },
    {
      "baseValue": 100,
      "field": "Weight",
      "delta": 10,
      "unit": "Percent",
      "cycleOffset": 2,
      "expected": 121.25
    },
    {
      "baseValue": 100,
      "field": "Weight",
      "delta": null,
      "unit": "Absolute",
      "cycleOffset": 3,
      "expected": 100
    },
    {
      "baseValue": null,
      "field": "Weight",
      "delta": 2.5,
      "unit": "Absolute",
      "cycleOffset": 2,
      "expected": null
    },
    {
      "baseValue": 10,
      "field": "Weight",
      "delta": -5,
      "unit": "Absolute",
      "cycleOffset": 3,
      "expected": 0
    },
    {
      "baseValue": 7,
      "field": "Rpe",
      "delta": 0.5,
      "unit": "Absolute",
      "cycleOffset": 2,
      "expected": 8.0
    },
    {
      "baseValue": 7,
      "field": "Rpe",
      "delta": 0.5,
      "unit": "Absolute",
      "cycleOffset": 10,
      "expected": 10
    },
    {
      "baseValue": 0,
      "field": "Rpe",
      "delta": -0.5,
      "unit": "Absolute",
      "cycleOffset": 0,
      "expected": 0
    },
    {
      "baseValue": 2,
      "field": "Rir",
      "delta": -1,
      "unit": "Absolute",
      "cycleOffset": 3,
      "expected": 0
    },
    {
      "baseValue": 2,
      "field": "Rir",
      "delta": 1,
      "unit": "Absolute",
      "cycleOffset": 3,
      "expected": 5
    },
    {
      "baseValue": 7,
      "field": "Rpe",
      "delta": null,
      "unit": "Absolute",
      "cycleOffset": 2,
      "expected": 7
    },
    {
      "baseValue": null,
      "field": "Rpe",
      "delta": 0.5,
      "unit": "Absolute",
      "cycleOffset": 2,
      "expected": null
    },
    {
      "baseValue": 40,
      "field": "Duration",
      "delta": 10,
      "unit": "Absolute",
      "cycleOffset": 3,
      "expected": 70
    },
    {
      "baseValue": 8,
      "field": "Reps",
      "delta": -2,
      "unit": "Absolute",
      "cycleOffset": 4,
      "expected": 1
    },
    {
      "baseValue": 400,
      "field": "Distance",
      "delta": 100,
      "unit": "Absolute",
      "cycleOffset": 2,
      "expected": 600
    },
    {
      "baseValue": 10,
      "field": "Speed",
      "delta": 0.5,
      "unit": "Absolute",
      "cycleOffset": 4,
      "expected": 12.0
    }
  ]
}
